import React from 'react';
import { getRedirectUrl } from 'app/ui/pages/shared/url-builder';
import RedirectOnce from 'app/ui/route/RedirectOnce';

export default function RedirectOffSite({ to, params }) {
  const redirect = getRedirectUrl(to, params);
  return <RedirectOnce to={redirect} />;
}



// WEBPACK FOOTER //
// ./src/app/ui/route/RedirectOffSite.js